import {
  UserRoleEnum,
  UserOmissionAttributeEnum,
} from "@/__generated__/graphql";
import { counselorsVar } from "@/reactiveVars/organization";
import { User } from "@/__generated__/types";
import { DEFAULT_OMISSIONS, useUsersByRoles } from "./useUsersByRoles";
import { useMemo } from "react";

export const useCounselors = (
  omissions: UserOmissionAttributeEnum[] = DEFAULT_OMISSIONS,
): {
  data: Partial<User>[] | null;
  loading: boolean;
} => {
  const roles = useMemo(() => [UserRoleEnum.Counselor], []);

  return useUsersByRoles({
    userReactiveVar: counselorsVar,
    roles,
    omissions,
  });
};
